import script from "./SectionPartnersBeplanet.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionPartnersBeplanet.vue?vue&type=script&setup=true&lang=js"

import "./SectionPartnersBeplanet.vue?vue&type=style&index=0&id=b01ba700&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b01ba700"]])

export default __exports__